import { render, staticRenderFns } from "./memocollection.vue?vue&type=template&id=0b761e03&scoped=true&"
import script from "./memocollection.vue?vue&type=script&lang=js&"
export * from "./memocollection.vue?vue&type=script&lang=js&"
import style0 from "./memocollection.vue?vue&type=style&index=0&id=0b761e03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b761e03",
  null
  
)

export default component.exports